import { Timestamp } from "firebase/firestore";

/**
 * Helper functions for working with extrasMap that supports both legacy (Timestamp)
 * and new format (ExtraMapEntry with challengeId)
 */

export const getExtraTimestamp = (entry: Timestamp | ExtraMapEntry): Timestamp => {
  if (entry instanceof Timestamp) {
    return entry;
  }
  return entry.timestamp;
};

export const getExtraChallengeId = (entry: Timestamp | ExtraMapEntry): string | undefined => {
  if (entry instanceof Timestamp) {
    return undefined;
  }
  return entry.challengeId;
};

export const isLegacyExtra = (entry: Timestamp | ExtraMapEntry): boolean => {
  return entry instanceof Timestamp;
};

export const createExtraMapEntry = (challengeId?: string): Timestamp | ExtraMapEntry => {
  if (!challengeId) {
    return Timestamp.now();
  }
  return {
    timestamp: Timestamp.now(),
    challengeId,
  };
};

export const getChallengeLinkedExtras = (
  extrasMap: Record<string, Timestamp | ExtraMapEntry>,
  challengeId: string,
): string[] => {
  return Object.entries(extrasMap)
    .filter(([extraId, entry]) => {
      // Skip video entries
      if (extraId.endsWith("-video")) return false;

      const linkedChallengeId = getExtraChallengeId(entry);
      return linkedChallengeId === challengeId;
    })
    .map(([extraId]) => extraId);
};
